export interface Product {
    label: string, 
    value: string;
    logo: string
}

export const kafintech_products: Product[] = [
    {
        label: "Kafintech Group",
        value: 'kafintechgroup',
        logo: '/companies/KAFINTECHGROUP.png'
    },
    {
        label: "Optimum Media",
        value: "optimummedia",
        logo: "/companies/OPTIMUM%20MEDIAS.png" // Espace encodé en %20
    },
    {
        label: "Izilife Pay",
        value: 'izilifepay',
        logo: "/companies/IZI%20LIFE%20PAY.png" // Espaces encodés en %20
    },
    {
        label: "Izi Trust Capital",
        value: 'izitrustcapital',
        logo: "/companies/IZITRUSTCAPITAL.png"
    },
    {
        label: "Izi Flow",
        value: 'iziflow',
        logo: "/companies/IZI%20FLOW.png" // Espace encodé en %20
    },
    {
        label: "Easy Life Market",
        value: 'easylifemarket',
        logo: "/companies/EASY%20LIFE%20MARKET.png" // Espaces encodés en %20
    },
    {
        label: "Izi Call Center",
        value: 'izicallcenter',
        logo: "/companies/IZI%20CALL%20CENTER.png" // Espaces encodés en %20
    },
    {
        label: "Bin Beyond",
        value: "binbeyond",
        logo: "/companies/Bin_Beyond_logo.png"
    }
];